import { createPortal } from "react-dom"
import styles from "./modal.module.css"



export function Modal({ open, children, onClose }) {
    if (!open) return null

    return createPortal(
        <>
            <div className={`${styles.overlay}   `} onClick={onClose} />
            <div className={styles.modal}>
                <div className={`${styles.burger_btn} ${open ? `open` : ""} }`}
                    onClick={onClose}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                {children}
            </div>
        </>,
        document.getElementById('root')
    )
}
